import React, { createContext, useContext, useEffect, ReactNode } from 'react'
import io, { Socket } from 'socket.io-client'
import { useAuth } from './AuthContext'

interface SocketContextType {
    socket: Socket | null
}

const SocketContext = createContext<SocketContextType | undefined>(undefined)

export const useSocket = () => {
    const context = useContext(SocketContext)
    if (context === undefined) {
        throw new Error('useSocket must be used within a SocketProvider')
    }
    return context
}

interface SocketProviderProps {
    children: ReactNode
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
    const { user, token } = useAuth()
    const [socket, setSocket] = React.useState<Socket | null>(null)

    useEffect(() => {

        if (user && token) {
            // In development, Socket.IO is proxied through Vite at the same origin
            // In production, we need to use the full backend URL
            const isDev = import.meta.env.DEV;
            const socketUrl = isDev ? '/' : (import.meta.env.VITE_API_URL?.replace('/api', '') || window.location.origin);

            const newSocket = io(socketUrl, {
                auth: {
                    token,
                },
                withCredentials: true,
                transports: ['websocket', 'polling'], // Prefer websocket, fallback to polling
                reconnection: true,
                reconnectionAttempts: 5,
                reconnectionDelay: 1000,
            })


            newSocket.on('connect', () => {
            });

            newSocket.on('disconnect', () => {
            });

            newSocket.on('connect_error', (error) => {
            });

            setSocket(newSocket)

            return () => {
                newSocket.close()
            }
        } else {
        }
    }, [user, token])

    const value = {
        socket,
    }

    return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
}